/* JCE Industrial Product V2 — self contained, Shopify Ajax Cart API */
(function () {
  'use strict';
  function setup(section) {
    if (!section || section.dataset.jceInitialized === 'true') return;
    section.dataset.jceInitialized = 'true';
    var parse = function (selector) {
      var el = section.querySelector(selector);
      try { return JSON.parse(el ? el.textContent : '{}'); } catch (e) { return {}; }
    };
    var variants = parse('[data-variants-json]');
    var variantMedia = parse('[data-variant-media-json]');
    if (!Array.isArray(variants)) variants = [];
    var variantInput = section.querySelector('[data-variant-id]');
    var form = section.querySelector('[data-jce-product-form]');
    var quantityInput = section.querySelector('[data-quantity]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addText = section.querySelector('[data-add-text]');
    var errorEl = section.querySelector('[data-form-error]');
    var stickyBar = section.querySelector('[data-sticky-cart]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var stickyBuy = section.querySelector('[data-sticky-buy]');
    var stickyError = section.querySelector('[data-sticky-error]');
    var buyPanel = section.querySelector('.jcev2__buy-panel');
    var isSubmitting = false;

    // Bulk Savings: view-only popup. Keeps real cart discount logic untouched.
    var bulkModal = section.querySelector('[data-bulk-dialog]');
    var bulkOpen = section.querySelector('[data-bulk-open]');
    var bulkDialog = section.querySelector('[data-bulk-dialog-content]');
    var bulkPreviousFocus = null;
    var bulkPreviousOverflow = '';
    function closeBulk() {
      if (!bulkModal || bulkModal.hidden) return;
      bulkModal.hidden = true;
      document.documentElement.style.overflow = bulkPreviousOverflow;
      if (bulkPreviousFocus && typeof bulkPreviousFocus.focus === 'function') bulkPreviousFocus.focus();
    }
    function openBulk() {
      if (!bulkModal) return;
      bulkPreviousFocus = document.activeElement;
      bulkPreviousOverflow = document.documentElement.style.overflow;
      bulkModal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (bulkDialog) bulkDialog.focus();
    }
    if (bulkOpen) bulkOpen.addEventListener('click', openBulk);
    if (bulkModal) {
      bulkModal.querySelectorAll('[data-bulk-close]').forEach(function(button){
        button.addEventListener('click', closeBulk);
      });
      bulkModal.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') { event.preventDefault(); closeBulk(); return; }
        if (event.key !== 'Tab') return;
        var focusable = Array.from(bulkModal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]'));
        if (!focusable.length) { event.preventDefault(); bulkDialog.focus(); return; }
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
    // Halloween coupon popup: independent of Bulk Savings and theme-wide coupon IDs.
    var couponModal = section.querySelector('[data-jce-coupon-modal]');
    var couponOpen = section.querySelector('[data-jce-coupon-open]');
    var couponDialog = section.querySelector('[data-jce-coupon-dialog]');
    var couponFocusBefore = null;
    var couponOverflowBefore = '';
    function closeCoupon() {
      if (!couponModal || couponModal.hidden) return;
      couponModal.hidden = true;
      document.documentElement.style.overflow = couponOverflowBefore;
      if (couponFocusBefore && typeof couponFocusBefore.focus === 'function') couponFocusBefore.focus();
    }
    function openCoupon() {
      if (!couponModal) return;
      couponFocusBefore = document.activeElement;
      couponOverflowBefore = document.documentElement.style.overflow;
      couponModal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (couponDialog) couponDialog.focus();
    }
    if (couponOpen) couponOpen.addEventListener('click', openCoupon);
    if (couponModal) {
      couponModal.querySelectorAll('[data-jce-coupon-close]').forEach(function(button) { button.addEventListener('click', closeCoupon); });
      couponModal.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') { event.preventDefault(); closeCoupon(); return; }
        if (event.key !== 'Tab') return;
        var focusable = Array.from(couponModal.querySelectorAll('button:not([disabled]),a[href],[tabindex="0"]'));
        if (!focusable.length) { event.preventDefault(); couponDialog.focus(); return; }
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      function oldBrowserCopy(txt) {
        var el = document.createElement('textarea');
        el.value = txt;el.setAttribute('readonly','');el.style.position = 'fixed';el.style.left = '-9999px';
        document.body.appendChild(el);el.select();
        var copied = false;
        try { copied = document.execCommand('copy'); } catch(e) { copied = false; }
        el.remove();return copied;
      }
      couponModal.addEventListener('click', function(event) {
        var button = event.target.closest('[data-jce-coupon-copy]');
        if (!button) return;
        var value = button.getAttribute('data-jce-coupon-copy');
        if (!value) return;
        var original = button.textContent;
        function setCopyResult(success) {
          button.textContent = success ? 'Copied!' : 'Copy failed';
          button.classList.toggle('is-copied',success);
          var live = couponModal.querySelector('[data-jce-coupon-live]');
          if (live) live.textContent = success ? value+' copied' : 'Unable to copy '+value;
          clearTimeout(button._couponResetTimer);
          button._couponResetTimer = setTimeout(function(){button.textContent = original;button.classList.remove('is-copied');},1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(function(){setCopyResult(true);}).catch(function(){setCopyResult(oldBrowserCopy(value));});
        } else {setCopyResult(oldBrowserCopy(value));}
      });
    }
    var optionGroups = Array.from(section.querySelectorAll('[data-option-group]'));
    var current = variants.find(function (v) { return String(v.id) === (variantInput && variantInput.value); }) || variants.find(function (v) { return v.available; }) || variants[0];
    var currency = section.dataset.currency || 'USD';
    function money(cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:currency}).format((Number(cents) || 0)/100); }
      catch(e) { return '$' + ((Number(cents) || 0)/100).toFixed(2); }
    }
    function qty() {
      var n = Number(quantityInput && quantityInput.value);
      return Number.isFinite(n) && n > 0 ? Math.min(99999, Math.floor(n)) : 1;
    }
    function showError(message) {
      if (errorEl) {
        errorEl.textContent = message || '';
        errorEl.hidden = !message;
      }
      if (stickyError) {
        stickyError.textContent = message || '';
        stickyError.hidden = !message;
      }
    }
    function activateMedia(mediaId) {
      var slides = Array.from(section.querySelectorAll('[data-slide]'));
      var chosen = slides.find(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
      if (!chosen) return;
      slides.forEach(function(s){
        var active = s === chosen;
        s.hidden = !active; s.classList.toggle('is-active',active);
        if (!active) s.querySelectorAll('video').forEach(function(v){v.pause();});
      });
      section.querySelectorAll('[data-thumb]').forEach(function(t){
        var active = String(t.dataset.mediaId) === String(mediaId);
        t.classList.toggle('is-active',active);
        t.setAttribute('aria-pressed', String(active));
        if (active) {
          var scroller = section.querySelector('[data-thumbs]');
          if (scroller) {
            var left = t.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
            var right = left + t.getBoundingClientRect().width;
            if (left < scroller.scrollLeft) scroller.scrollTo({left:left-4,behavior:'smooth'});
            else if (right > scroller.scrollLeft + scroller.clientWidth) scroller.scrollTo({left:right-scroller.clientWidth+4,behavior:'smooth'});
          }
        }
      });
      var zoom = section.querySelector('[data-zoom-open]');
      if (zoom) zoom.hidden = chosen.dataset.mediaType !== 'image';
      // Show the associated variant image in the bottom purchase bar too.
      var stickyImage = section.querySelector('[data-sticky-image]');
      var activeThumb = Array.from(section.querySelectorAll('[data-thumb]')).find(function (el) {
        return String(el.dataset.mediaId) === String(mediaId);
      });
      if (stickyImage && activeThumb) {
        var thumbImage = activeThumb.querySelector('img');
        if (thumbImage) stickyImage.src = thumbImage.src;
      }

    }
    function updateAvailability() {
      if (!current) return;
      var selected = [current.option1,current.option2,current.option3];
      optionGroups.forEach(function (group) {
        var index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach(function (button) {
          var value = button.dataset.optionValue;
          var active = selected[index] === value;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
          var canBuy = variants.some(function (v) {
            return v.available && [v.option1,v.option2,v.option3][index] === value;
          });
          // Permit a selected sold-out choice to remain visible and selected.
          button.disabled = !canBuy && !active;
          button.title = !canBuy && !active ? 'Unavailable for this combination' : '';
        });
      });
    }
    function refresh() {
      if (!current) return;
      if (variantInput) variantInput.value = current.id;
      var sku = section.querySelector('[data-product-sku]');
      if (sku) sku.textContent = current.sku || '—';
      var stock = section.querySelector('[data-stock]');
      if (stock) {
        stock.classList.toggle('is-out', !current.available);
        var showCount = section.dataset.inventoryCount === 'true';
        var count = showCount && current.inventory_management && Number(current.inventory_quantity) > 0 ? ' ('+Number(current.inventory_quantity).toLocaleString()+' units)' : '';
        stock.textContent = current.available ? '● In stock'+count : 'Out of stock';
      }
      var price = section.querySelector('[data-unit-price]');
      var compare = section.querySelector('[data-compare-price]');
      var subtotal = section.querySelector('[data-subtotal]');
      var totalCompare = section.querySelector('[data-subtotal-compare]');
      var savings = section.querySelector('[data-saving]');
      var number = qty();
      if (quantityInput) quantityInput.value = number;
      if (price) price.textContent = money(current.price);
      if (subtotal) subtotal.textContent = money(current.price * number);
      var hasCompare = Number(current.compare_at_price) > Number(current.price);
      if (compare) {compare.hidden = !hasCompare; if(hasCompare) compare.textContent = money(current.compare_at_price);}
      if (totalCompare) {totalCompare.hidden = !hasCompare; if(hasCompare) totalCompare.textContent = money(current.compare_at_price * number);}
      if (savings) {
        savings.hidden = !hasCompare;
        if (hasCompare) savings.textContent = 'You save ' + money((current.compare_at_price-current.price)*number);
      }
      if(addBtn) addBtn.disabled = isSubmitting || !current.available;
      if(addText) addText.textContent = current.available ? 'Add to cart' : 'Sold out';
      // The sticky bar reads the same `current` variant and `qty()` as the main product form.
      var stickyPrice = section.querySelector('[data-sticky-price]');
      var stickyCompare = section.querySelector('[data-sticky-compare]');
      var stickyPercent = section.querySelector('[data-sticky-percent]');
      var stickyVariant = section.querySelector('[data-sticky-variant]');
      if (stickyPrice) stickyPrice.textContent = money(current.price);
      if (stickyCompare) {
        stickyCompare.hidden = !hasCompare;
        if (hasCompare) stickyCompare.textContent = money(current.compare_at_price);
      }
      if (stickyPercent) {
        stickyPercent.hidden = !hasCompare;
        if (hasCompare) stickyPercent.textContent = '-' + Math.round((current.compare_at_price - current.price) / current.compare_at_price * 100) + '%';
      }
      if (stickyVariant) {
        stickyVariant.hidden = !current.title || current.title === 'Default Title';
        stickyVariant.textContent = current.title || '';
      }
      if (stickyAdd) stickyAdd.disabled = isSubmitting || !current.available;
      if (stickyBuy) stickyBuy.disabled = isSubmitting || !current.available;
      updateAvailability();
    }
    optionGroups.forEach(function(group){
      var index = Number(group.dataset.optionIndex);
      group.addEventListener('click',function(event){
        var button = event.target.closest('[data-option-value]');
        if(!button || button.disabled || !current) return;
        var value = button.dataset.optionValue;
        var old = [current.option1,current.option2,current.option3];
        // Prefer exact combination. If none, try an available variant with requested value.
        var target = variants.find(function(v){ return v.available && [v.option1,v.option2,v.option3].every(function(opt,i){return i === index ? opt === value : opt === old[i];}); });
        if (!target) target = variants.find(function(v){return v.available && [v.option1,v.option2,v.option3][index] === value;});
        if (!target) {showError('This selection is not available.');return;}
        current = target;
        showError('');refresh();
        var mid = variantMedia[String(current.id)];
        if(mid) activateMedia(mid);
        var link = new URL(window.location.href);
        link.searchParams.set('variant', String(current.id));
        window.history.replaceState({},'',link.toString());
      });
    });
    // Click the top Judge.me badge to open the existing Reviews tab below.
    // Theme tab structures vary; look for the external Reviews tab first,
    // then fall back to the Judge.me widget or an existing reviews anchor.
    function jumpToReviews() {
      var labelPattern = /^reviews?(?:\s*\(\d+\))?$/i;
      var tabSelectors = [
        '[role="tab"]', '.tabs__tab', '.tabs__title', '.tab-link',
        '.tab-title', '.product-tabs a', '.product-tabs button',
        '.product-page-tabs a', '.product-page-tabs button',
        '[data-tab]', 'button', 'a', 'label'
      ].join(',');
      var tabs = Array.from(document.querySelectorAll(tabSelectors));
      var tab = tabs.find(function (el) {
        if (section.contains(el)) return false;
        var txt = (el.textContent || '').replace(/\s+/g, ' ').replace(/^[★☆⭐\s]+/g, '').trim();
        var tabId = [el.getAttribute('data-tab'), el.getAttribute('aria-controls'), el.getAttribute('data-target')].filter(Boolean).join(' ');
        return labelPattern.test(txt) || /(?:^|[\W_-])reviews?(?:$|[\W_-])/i.test(tabId);
      });
      var target = null;
      if (tab) {
        target = tab.closest('[role="tablist"],.product-tabs,.product-page-tabs,.tabs__nav,.tabs-nav,.tab-nav') || tab;
        var clickEl = tab.matches('button,a,label,[role="tab"]') ? tab : (tab.querySelector('button,a,label,[role="tab"]') || tab);
        clickEl.click();
      }
      var reviewWidget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg');
      if (!target) target = reviewWidget;
      if (!target) target = document.getElementById('reviews');
      if (!target) return;
      // Allow tabs to reveal their content before positioning the viewport.
      window.setTimeout(function () {
        var scrollEl = target;
        if (tab && target === tab && reviewWidget && reviewWidget.getClientRects().length) scrollEl = reviewWidget;
        var top = scrollEl.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({top: Math.max(0, top), behavior: 'smooth'});
      }, 90);
    }
    var reviewJump = section.querySelector('[data-review-jump]');
    if (reviewJump) {
      reviewJump.style.cursor = 'pointer';
      reviewJump.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        jumpToReviews();
      }, true);
      reviewJump.addEventListener('keydown', function (event) {
        if (event.target !== reviewJump || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        jumpToReviews();
      });
    }
    section.querySelectorAll('[data-thumb]').forEach(function(button){
      button.addEventListener('click',function(){ activateMedia(button.dataset.mediaId); });
    });
    function shiftThumb(delta) {
      var thumbs = Array.from(section.querySelectorAll('[data-thumb]'));
      if(!thumbs.length) return;
      var pos = thumbs.findIndex(function(t){return t.classList.contains('is-active');});
      var next = thumbs[(pos + delta + thumbs.length) % thumbs.length];
      activateMedia(next.dataset.mediaId);
    }
    // Navigation is shown over the hero instead of beside the thumbnails.
    var hero = section.querySelector('[data-gallery]');
    var heroPrev = section.querySelector('[data-hero-prev]');
    var heroNext = section.querySelector('[data-hero-next]');
    if (heroPrev) heroPrev.addEventListener('click', function(event){event.stopPropagation();shiftThumb(-1);});
    if (heroNext) heroNext.addEventListener('click', function(event){event.stopPropagation();shiftThumb(1);});
    // Native vertical scrolling is preserved; horizontal swipes move the hero media.
    var touchStartX = null, touchStartY = null, lastHeroSwipe = 0;
    if (hero && section.querySelectorAll('[data-slide]').length > 1) {
      hero.addEventListener('touchstart', function(event) {
        if (event.touches.length !== 1 || event.target.closest('button, video, iframe, model-viewer')) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, {passive:true});
      hero.addEventListener('touchend', function(event) {
        if (touchStartX === null || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - touchStartX;
        var dy = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          lastHeroSwipe = Date.now();
          shiftThumb(dx < 0 ? 1 : -1);
        }
      }, {passive:true});
      hero.addEventListener('touchcancel', function() { touchStartX = null; touchStartY = null; }, {passive:true});
    }
    var minus = section.querySelector('[data-qty-minus]');
    var plus = section.querySelector('[data-qty-plus]');
    if(minus) minus.addEventListener('click',function(){quantityInput.value=Math.max(1,qty()-1);refresh();});
    if(plus) plus.addEventListener('click',function(){quantityInput.value=Math.min(99999,qty()+1);refresh();});
    if(quantityInput) quantityInput.addEventListener('change',refresh);
    var lightbox = section.querySelector('[data-lightbox]');
    var lightboxImg = section.querySelector('[data-lightbox-image]');
    function closeZoom(){if(lightbox) lightbox.hidden=true;document.documentElement.style.removeProperty('overflow');}
    function openZoom(){
      var active = section.querySelector('[data-slide].is-active [data-zoom-image]');
      if(!active || !lightbox || !lightboxImg) return;
      lightboxImg.src=active.dataset.zoomImage;lightboxImg.alt=active.alt||'';
      lightbox.hidden=false;document.documentElement.style.overflow='hidden';
      var close=section.querySelector('[data-zoom-close]');if(close) close.focus();
    }
    var zoom = section.querySelector('[data-zoom-open]');
    if(zoom) zoom.addEventListener('click',openZoom);
    section.querySelectorAll('[data-slide] img[data-zoom-image]').forEach(function(img){ img.addEventListener('click',function(){if (Date.now() - lastHeroSwipe > 450) openZoom();}); });
    var close = section.querySelector('[data-zoom-close]');
    if(close) close.addEventListener('click',closeZoom);
    if(lightbox) lightbox.addEventListener('click',function(e){if(e.target===lightbox)closeZoom();});
    section.addEventListener('keydown',function(e){if(e.key==='Escape' && lightbox && !lightbox.hidden)closeZoom();});
    // Single request handler for main purchase form AND sticky actions.
    // Buy now adds the same currently selected item to the existing Shopify cart
    // and then proceeds to checkout; it does not clear existing cart contents.
    async function purchase(goCheckout) {
      if (isSubmitting) return;
      if (!current || !current.available) { showError('This item is currently unavailable.'); return; }
      if (!window.fetch) {
        if (!goCheckout && form) form.submit();
        else showError('Please use the main Add to cart button.');
        return;
      }
      showError('');
      isSubmitting = true;
      refresh();
      if (addText) addText.textContent = 'Adding…';
      if (stickyAdd) stickyAdd.textContent = 'Adding…';
      if (stickyBuy) stickyBuy.textContent = 'Please wait…';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (!root.endsWith('/')) root += '/';
      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:Number(current.id),quantity:qty()}]})
        });
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
        window.location.assign(root + (goCheckout ? 'checkout' : 'cart'));
      } catch (err) {
        showError(err.message || 'Unable to add this item.');
        isSubmitting = false;
        refresh();
        if (stickyAdd) stickyAdd.textContent = 'Add to cart';
        if (stickyBuy) stickyBuy.textContent = 'Buy now';
      }
    }
    if (form) form.addEventListener('submit', function(event) {
      event.preventDefault();
      purchase(false);
    });
    if (stickyAdd) stickyAdd.addEventListener('click', function() { purchase(false); });
    if (stickyBuy) stickyBuy.addEventListener('click', function() { purchase(true); });

    // Only appear after the MAIN purchase area has scrolled past the viewport.
    // Keep the handler scoped to this section and throttle with requestAnimationFrame.
    if (stickyBar && buyPanel) {
      var stickyTicking = false;
      function updateStickyVisibility() {
        stickyTicking = false;
        if (!section.isConnected) return;
        var rect = buyPanel.getBoundingClientRect();
        // Hides again as soon as the main purchase controls come back into view.
        var shouldShow = rect.bottom < 85 && window.scrollY > 150;
        stickyBar.hidden = !shouldShow;
      }
      function queueStickyVisibility() {
        if (stickyTicking) return;
        stickyTicking = true;
        window.requestAnimationFrame(updateStickyVisibility);
      }
      window.addEventListener('scroll', queueStickyVisibility, {passive:true});
      window.addEventListener('resize', queueStickyVisibility, {passive:true});
      document.addEventListener('shopify:section:unload', function(event) {
        if (event.target === section || event.target.contains(section)) {
          window.removeEventListener('scroll', queueStickyVisibility);
          window.removeEventListener('resize', queueStickyVisibility);
        }
      });
      queueStickyVisibility();
    }
    refresh();
  }
  function init(root){
    if (root.matches && root.matches('[data-jce-product-section]')) setup(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-jce-product-section]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){init(document);});
  else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
